/**
 * Jeton à présenter aux passerelles temps réel (socket.io).
 *
 * Depuis le 16/09/2026, les namespaces `/messaging` et `/live` refusent une
 * connexion sans jeton : `handleConnection` était vide côté serveur et
 * l'identité se déclarait dans le corps du message — n'importe qui se disait
 * vendeur, lisait la messagerie du magasin et écrivait aux clients sous
 * l'identité du commerçant (audit du 15/09/2026).
 *
 * La priorité reprend EXACTEMENT celle de l'ApiClient (`services/api.ts`) :
 * sur la boutique, le jeton client d'abord ; ailleurs, celui du personnel.
 * Sans quoi un vendeur ayant fait ses courses sur l'eshop dans le même
 * navigateur se connecterait au chat de la caisse en tant que client.
 */
export function jetonTempsReel(): string | null {
  const jetonClient = localStorage.getItem('customer_token');
  const jetonPersonnel = localStorage.getItem('auth_token');
  const surLaBoutique =
    window.location.pathname.startsWith('/shop') ||
    window.location.pathname.startsWith('/sales/');
  return surLaBoutique
    ? jetonClient || jetonPersonnel
    : jetonPersonnel || jetonClient;
}
